import store, { appActions } from '@apply/adminStore';

export const setAppLoading = (status, message) => {
    const { dispatch } = store;
    dispatch(appActions.setAppError(false));
    dispatch(appActions.setAppLoading(status, message));
};

export const setAppError = (status, message) => {
    const { dispatch } = store;
    dispatch(appActions.setAppLoading(false));
    dispatch(appActions.setAppError(status, message));
};

export const setAppAction = (status, message) => {
    const { dispatch } = store;
    dispatch(appActions.setAppAction(status, message));
};

export const appState = store.getState();
